//inherit guard questionniare
import React, { useState, useEffect } from "react";
import "./customCart.css";
import "./questionnaireResponsive.css";
import QuestionStep from "./QuestionStep";
import { useSearchParams } from "react-router-dom";
function Questionnaire() {
  let propList=<ul>
  <li>A substantial business that you want included in your trust</li>
  <li>Rental property</li>
  <li>NFA or collectible firearms</li>
    <li>Property outside the U.S. or on tribal land</li>
  <li>Intellectual property (like patents or copyrights)</li>
  <li>Valuable heirlooms or collections</li>
</ul>
  const [params, setParams] = useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    useEffect(()=>{
      const param = searchParams.get("tp");
    setParams((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData.param = param;
      return updatedFormData;
    });
    },[])
  const [qualifies, setQualifies] = useState({

    ///these are possible reasons someone could not qualify for a simple/trust plus plan
    values: {
      isMarried: "",
      planSeparate: "",
      separated: "",
      greenCard: "",
      haveKids: "",
      specialNeeds: "",
      disinherit: "",
      guardianship: "",
      outsideUS: "",
      ownershipList: "",
      otherSpecialNeeds: "",
      medicaid: "",
      protectAsset: "",
      highLiability: "",
      threeMil: "",
      sevenMil: "",
      charity: "",
      update: "",
      louisiana: "",
      specialState:""

    },
    ///these are the reasons spelled out so we can display them to the end user
    reasons: [  {
        question:"planSeparate",
        reason:"You are trying to plan separately from your spouse, keep assets separate, or ensure your spouse cannot disinherit your children."
      },
      {
        question:"separated",
        reason:"You are separated from your spouse without a court ordered legal separation."
      },
      {
        question:"greenCard",
        reason:"You or your spouse are a non U.S. citizen without a Green Card."
      },
      {
        question:"specialNeeds",
        reason:"One of your children or beneficiaries have special needs, disabilities, or receive government assistance."
      },
      {
        question:"disinherid",
        reason:"You want to disinherit a child or leave them only a minimal amount."
      },
      {
        question:"guardianship",
        reason:"You have a child who will require guardianship or special supervision as an adult."
      },
      {
        question:"outsideUS",
        reason:"Your chosen guardian for minor children lives outside the United States."
      },
       {
        question:"otherSpecialNeeds",
        reason:"You are leaving assets to anyone (other than your children) who has special needs or receives SSI/Medicaid."
      },
       {
        question:"ownershipList",
        reason:"You own property or a business that requires custom consideration."
      },
       {
        question:"medicaid",
        reason:"You want to plan ahead for Medicaid, Medi‑Cal, or Veteran benefits."
      },
       {
        question:"protectAsset",
        reason:"You want to protect your assets (or your heirs’ assets) from lawsuits, creditors, or divorce."
      },
       {
        question:"highLiability",
        reason:"You work in a profession with higher liability risk."
      },
      {
        question:"sevenMil",
        reason:"Your estate is likely to be more than $7 million."
      },
      {
        question:"threeMil",
        reason:"You live in a state with its own estate or inheritance tax, and your estate is likely to be more than $2 million."
      },
      {
        question:"charity",
        reason:"You are planning to leave a significant amount to charity."
      },
      {
        question:"update",
        reason:"You already have a trust and want to update it."
      },
      {
        question:"louisiana",
        reason:"You live in Louisiana or Hawaii."
      },
    
    ],
    reasons2: [
    

    ],
  });
  const [password, setPassword] = useState({ password: "", passwordType: "" });

  ///list of questions we ask to vet if someone quailfies for a simple/trustPlus plan

  const [questions, setQuestions] = useState({
    section1: {
      title: "YOUR RELATIONSHIP STATUS",
      hasHeader: true,
      header: {
        question: "Are you currently married?",
        reason: "",
        name: "isMarried",
        value: qualifies.values["isMarried"],
        display: true,
      },
      questionArray: [
        {
          question:"Are you trying to plan separately from your spouse, keep assets separate, or ensure your spouse cannot disinherit your children?",
         
            
          reason: "",
          name: "planSeparate",
          value: qualifies.values["planSeparate"],
          display: true,
        },
        {
          question:
            "Are you separated from your spouse without a court ordered legal separation?",
          reason: "",
          name: "separated",
          value:qualifies.values["separated"],
          display: true,
           needPad:true,
        },
        {
          question:
            "Are you or your spouse a non U.S. citizen without a Green Card?",
          reason: "",
          name: "greenCard",
          value: qualifies.values["greenCard"],
          display: true,
        },
      ],
    },
    section2: {
      title: "YOUR CHILDREN",
      hasHeader: true,
      header: {
        question:
          "Do you have any children or plan to leave assets to younger beneficiaries?",
        reason: "",
        name: "haveKids",
        value: false,
        display: true,
      },
      questionArray: [
        {
          question:"Do any of your children or beneficiaries have special needs, disabilities, or receive government assistance (SSI, Medicaid)?",
      needPad:true,
          reason: "",
          name: "specialNeeds",
          value: false,
          display: true,
        },
        {
          question:
            "Do you want to disinherit a child or leave them only a minimal amount?",
          reason: "",
          name: "disinherid",
          value: false,
          display: true,
               needPad:true,
        },
        {
          question:
            "Do you have a child who will require guardianship or special supervision as an adult?",
          reason: "",
          name: "guardianship",
          value: false,
          display: true,
        },
        {
          question:
            "Is your chosen guardian for minor children living outside the United States?",
          reason: "",
          name: "outsideUS",
          value: false,
          display: true,
        },
      ],
    },
    section3: {
      title: "OTHER PEOPLE YOU'RE LEAVING ASSETS TO",
      questionArray: [
        {
          question:"Are you leaving assets to anyone (other than your children) who has special needs or receives SSI/Medicaid ?",
          
          reason: "",
          name: "otherSpecialNeeds",
          value: qualifies.values["otherSpecialNeeds"],
          display: true,
        },
      ],
    },
    section4: {
      title: "WHAT YOU OWN",
      questionArray: [
        {
          question: `Do you own any of the following?`,
          extras:propList,
          reason: "",
          name: "ownershipList",
          value: qualifies.values["ownershipList"],
          display: true,
        },
      ],
    },
    section5: {
      title: "LONG-TERM CARE & PROTECTING YOUR ASSETS",
      questionArray: [
        {
          question:
            "Do you want to plan ahead for Medicaid, Medi‑Cal, or Veteran benefits?",
          reason: "",
          name: "medicaid",
          value: qualifies.values["medicaid"],
          display: true,
        },
        {
          question:
            "Do you want to protect your assets (or your heirs’ assets) from lawsuits, creditors, or divorce?",
          reason: "",
          name: "protectAsset",
          value: qualifies.values["protectAsset"],
          display: true,
        },
        {
          question:
            "Do you work in a profession with higher liability risk (like a doctor or dentist)?",
          reason: "",
          name: "highLiability",
          value: qualifies.values["highLiability"],
          display: true,
        },
      ],
    },
    section6: {
      title: "TAXES",
      hasHeader: true,
      header: {
        question:
          "Do you live in a state with its own estate or inheritance tax?",
          extras:"(i.e. CT, HI, IL, ME, MD, MA, MN, NY, OR, RI, VT, WA, DC,IA, KY, MD, NE, NJ, PA)",
        reason: "",
        name: "specialState",
        value: qualifies.values["specialState"],
        display: true,
      },
      questionArray: [
        {
          question: "Is your estate likely to be more than $7 million?",
          reason: "",
          name: "sevenMil",
          value: qualifies.values["sevenMil"],
          matchWithHeader: "false",

        },
        {
          question: " Is your estate likely to be more than $2 million?",
          reason: "",
          name: "threeMil",
          value: qualifies.values["threeMil"],
         matchWithHeader:"true"
        },
        
      ],
    },
    section7: {
      title: "SPECIAL SITUATIONS",
      questionArray: [
        {
          question:
            "Are you planning to leave a significant amount to charity?",
          reason: "",
          name: "charity",
          value: qualifies.values["charity"],
          display: true,
        },
        {
          question: "Do you already have a trust and want to update it?",
          reason: "",
          name: "update",
          value:  qualifies.values["update"],
          display: true,
        },
        {
          question: "Do you live in Louisiana or Hawaii?",
          reason: "",
          name: "louisiana",
          value: qualifies.values["louisiana"],
          display: true,
        },
      ],
    },
  });
  const [anythingTrue, setAnythingTrue] = useState({
    isAnythingTrue: false,
    isSubmitted: false,
    reasons: "",
  });
  const [flipper,setFlipper]=useState({
    currentStep:1,
    steps:[
    1,2,3,4,5,6,7
  ]})
  // useEffect(() => {

  //   setAnythingTrue((prevState) => {
  //     const pd = {
  //       ...prevState,
  //     };
  //     pd.isAnythingTrue = isAnythingTrue;
  //     return pd;
  //   });
  // }, [qualifies]);

  const onFormFieldChange = (event) => {
    const target = event.target;
    let value = target.value;
    let name = target.name;
    console.log(value,name)
    setQualifies((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.values[name] = value;

      return pd;
    });
   
  };
  const onFormFieldChange2 = (event) => {
    const target = event.target;
    let value = target.value;
    let name = target.name;
    setPassword((prevState) => {
      const pd = {
        ...prevState,
      };
      pd[name] = value;
      return pd;
    });
  };

  //checks if any diqualifying question is "yes"
  //if yes, shows the reasons to the client and sends them to a custom plan appointment page
  //if all are no, says they may qualify and sends them to a trust plus appointment page
  const submitForm = (e) => {
    e.preventDefault();
    let copyQualifies = { ...qualifies.values };
    delete copyQualifies.isMarried
    delete copyQualifies.haveKids
    delete copyQualifies.specialState
    const isAnythingTrue = Object.values(copyQualifies).some(
      (item) => item === "true",
    );
    console.log("anything", isAnythingTrue);
    setAnythingTrue((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.isAnythingTrue = isAnythingTrue;
      pd.isSubmitted = true;
      return pd;
    });

    if (isAnythingTrue) {
      let reasonArray=qualifies.reasons
      let finalReasons=[]
      for (let i = 0; i < reasonArray.length; i++) {
        const currentReason = reasonArray[i];
        if(copyQualifies[currentReason.question]=="true")
        {
          finalReasons.push(currentReason.reason)
        }
        setQualifies((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.reasons2 = finalReasons;
        return pd;
      });
      }

    }
  };
  const submitForm2 = (e) => {
    e.preventDefault();
    const passCopy = password.passwordType.toLowerCase();
    //passCopy.toLowerCase()
    if (passCopy == "2kplan") {
      setPassword((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.password = passCopy;
        return pd;
      });
    } else {
      alert("Incorrect Password");
    }
  };
  ///go to next question
  const flipForward=(e)=>{
    e.preventDefault()
  

    if(flipper.currentStep===7)
    {

    }
    else{
      let currentSection=questions[`section${flipper.currentStep}`]
      console.log(currentSection)
      let currentQuestions=currentSection.questionArray
      let allFilled=false
      let numberOfQuestions=currentQuestions.length
      let numberOfTrue=0

      for (let i = 0; i < currentQuestions.length; i++) {        const currentQ = currentQuestions[i];
        if(qualifies.values[currentQ.name]!="")
        {
          numberOfTrue++
        }
      }
    if(
      
      (numberOfTrue===numberOfQuestions||numberOfTrue>0&&currentSection.title==="TAXES")
       ||qualifies.values[currentSection?.header?.name]==="false"
    )

    {  
    setFlipper((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.currentStep = flipper.currentStep+1;
        return pd;
      });
    }
    else{
      alert("You must answer all questions before moving forward.")
    }
    }
  
  }

  ///go to previous question
  const flipBack=()=>{

    if(flipper.currentStep===1)
    {
      
    }
    else{
    setFlipper((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.currentStep = flipper.currentStep-1;
        return pd;
      });
    }
  }
  return (
    <div id="big-div" className="vetting-page">
      {(password.password != "2kplan"&&params.param=="plus") && (
        <section className="vetting-password-section">
          <form onSubmit={submitForm2}>
            <div class="mb-3">
              <label for="exampleInputPassword1" class="form-label">
                Please enter the password given to you in the EPS Training
                Seminar
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputPassword1"
                name="passwordType"
                value={password.passwordType}
                onChange={onFormFieldChange2}
              />
            </div>

            <button type="submit" class="btn btn-primary">
              Submit
            </button>
          </form>
        </section>
      )}
      {(password.password == "2kplan"||params.param==="nata") && (

        
         <div className="vetting-page-container">
           <section className="content-section vetting-main-section">
             
          <QuestionStep section={questions[`section${flipper.currentStep}`]} onFormFieldChange={onFormFieldChange} values={qualifies.values} flipBack={flipBack} flipForward={flipForward} flipper={flipper} submitForm={submitForm}/>
          {anythingTrue.isAnythingTrue && anythingTrue.isSubmitted && (
              <div style={{ textAlign: "center" }}>
                <h2>
                  Due to your answers on the vetting questionnaire, you
                  indicated that:<br></br>
                  <br></br>
                  {
                    <ul style={{ textAlign: "left" }}>
                      {qualifies.reasons2.map((item, index) => (
                        <li>{item}</li>
                      ))}
                    </ul>
                  }{" "}
                  <strong>Due to the reasons above, your plan does not qualify for a simple plan.</strong>
                  to address the above circumstance, your situation requires a custom plan with an attorney starting at $3,900.
                  Please click the link below to be taken to our scheduling
                  page.
                </h2>
                <br></br>
                {/* <a href="https://inheritguard.com/appointments/">
                <h3>Click here to schedule your custom initial consultation</h3>
              </a> */}
                {params.param==="plus" &&<a href="https://inheritguard.com/custom-appointments/">
                  <button className="btn btn-primary">Click Here</button>
                </a>}
                  {params.param==="nata" &&<a href="https://inheritguardnata.com/custom-nata/">
                  <button className="btn btn-primary">Click Here</button>
                </a>}
              </div>
            )}
            {!anythingTrue.isAnythingTrue && anythingTrue.isSubmitted && params.param==="plus" &&(
              <div style={{ textAlign: "center" }}>
                <h2>
                  Due to your answers on the vetting questionnaire,{" "}
                  <strong> you qualify for a TrustGuard Plus+ Plan.</strong>{" "}
                  Please click the link below to be taken to our TrustGuard Plus+ form.
                </h2>
                <br></br>
                <a href="https://inheritguard.fillout.com/t/2bSYELCZiNus">
                  <button className="btn btn-secondary"><span style={{"color":"#0E317E"}}>Trust</span><span style={{"color":"#9EA84F"}}>Guard</span> <span style={{"color":"#0E317E"}}>Plus+</span> Form</button>
                </a>
                 {/* <h2>
                  If you would like to go straight to a regular TrustGuard Design Meeting with a processor, click below.
                </h2>

                <a href="https://inheritguard.com/trust-guard-design/">
                  <button className="btn btn-primary">Trust Guard Design Meeting</button>
                </a> */}

              </div>

            )}
                 {!anythingTrue.isAnythingTrue && anythingTrue.isSubmitted && params.param==="nata" &&(
              <div style={{ textAlign: "center" }}>
                <h2>
                  Due to your answers on the vetting questionnaire,{" "}
                  <strong> you may qualify for a Simple Plan.</strong>{" "}
                  Please click the link below to be taken to our scheduling
                  page.
                </h2>
                <br></br>
                <a href="https://inheritguardnata.com/nata-appointments/">
                  <button className="btn btn-secondary"><span style={{"color":"#0E317E"}}>Trust</span><span style={{"color":"#9EA84F"}}>Guard</span> <span style={{"color":"#0E317E"}}>Form</span></button>
                </a>
                 {/* <h2>
                  If you would like to go straight to a regular TrustGuard Design Meeting with a processor, click below.
                </h2>

                <a href="https://inheritguard.com/trust-guard-design/">
                  <button className="btn btn-primary">Trust Guard Design Meeting</button>
                </a> */}

              </div>

            )}
        
       
          </section>
          </div>
       
      )}
    </div>
  );
}

export default Questionnaire;
